import React from 'react';
import { useNavigate, useLocation, useParams, useSearchParams } from 'react-router-dom';

// Higher-order component to provide router props to class components
// This replaces the withRouter HOC that was removed in React Router v6
function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        const navigate = useNavigate();
        const location = useLocation();
        const params = useParams();
        const [searchParams] = useSearchParams();

        return (
            <Component
                {...props}
                navigate={navigate}
                location={location}
                params={params}
                searchParams={searchParams}
            />
        );
    }

    return ComponentWithRouterProp;
}

export default withRouter;
